/**
 * Toast Utility - Disabled Version
 *
 * This utility replaces the toast functions with empty functions
 * to prevent errors when toast notifications are called throughout the app.
 */

// Create a dummy toast object with all the methods used in the app
const toast = {
  success: () => {},
  error: () => {},
  info: () => {},
  warn: () => {},
  // Add any other methods used in the app
};

export default toast;
